import { Box, Stack } from "@mui/material"
import React, { useState } from "react"
import { Ingredient } from "../../../../types/types"
import IngredientCategoryButton from '../IngredientCategoryButton'
import { INGREDIENT_TYPES } from "src/constants"
import SignOutButton from '../SignOutButton'

import './IngredientCategoryPicker.scss'
import BrandButton from "src/components/BrandButton"

export type IngredientCategoryPickerProps = {
    currentCategory: number;
    ingredients: Ingredient[];
    onChange: (category: number) => void;
}

const IngredientCategoryPicker = (props: IngredientCategoryPickerProps) => {

    const currentCategory = props.currentCategory

    const handleSelect = (category: number) => {
        props.onChange(category)
    }

    return (
        <Box className="ingredient-category-picker">
            <Stack spacing={0} className="ingredients-toolbar">
                <BrandButton />
                <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.PRODUCE}
                    category={INGREDIENT_TYPES.PRODUCE}
                    onSelect={handleSelect}
                    title="Produce"
                    useCount={0}
                />
                <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.VIDEO}
                    category={INGREDIENT_TYPES.VIDEO}
                    onSelect={handleSelect}
                    title="Video"
                    useCount={0}
                />
                <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.AUDIO}
                    category={INGREDIENT_TYPES.AUDIO}
                    onSelect={handleSelect}
                    title="Audio"
                    useCount={0}
                />
                <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.DETECT}
                    category={INGREDIENT_TYPES.DETECT}
                    onSelect={handleSelect}
                    title="Detect"
                    useCount={0}
                />
                <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.GENERATE}
                    category={INGREDIENT_TYPES.GENERATE}
                    onSelect={handleSelect}
                    title="Generate"
                    useCount={0}
                />
                <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.AR}
                    category={INGREDIENT_TYPES.AR}
                    onSelect={handleSelect}
                    title="AR"
                    useCount={0}
                />
                {/* <IngredientCategoryButton
                    active={currentCategory == INGREDIENT_TYPES.QUIZZING}
                    category={INGREDIENT_TYPES.QUIZZING}
                    onSelect={handleSelect}
                    title="Quiz Generation"
                    useCount={0}
                /> */}
                <SignOutButton />
            </Stack>
        </Box>
    )
}



export default IngredientCategoryPicker